// src/apis/featureFlags.ts
import { baseURL } from "../utils/constants";
import apiClient from "./fetch";
import { FeatureFlagsUpdate } from "../utils/types";

/**
 * GET /api/v1/featureflags/:hospitalId
 * Returns the single FeatureFlags object for the given hospital.
 */
export const getFeatureFlagsByHospitalId = async (
  hospital_id: string
)=> {
  try {
    const response = await apiClient.get( `${baseURL}/featureflags/${hospital_id}`);
    // console.log("FeatureFlags API Response:", response.data);
    return response
  } catch (error: any) {
    if (error.response && error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};


export const patchFeatureFlagsByHospitalId = async (
  hospital_id: string,
  data: FeatureFlagsUpdate
) => {
  try {
    const response = await apiClient.patch(`${baseURL}/api/v1/featureflags/${hospital_id}`,data);
    return response.data.result;
  } catch (error: any) {
    if (error.response) {
      console.error("FeatureFlags API Error:", error.response.status, error.response.data);
      return Promise.reject(
        new Error(error.response.data.message || "Failed to update feature flags")
      );
    }
    console.error("Unexpected API Error:", error);
    throw error;
  }
};
